import React from 'react';
import { useAppSelector } from '../../store/store';
import { buildSearchMetadata } from '../../../shared/metadata';
var Metadata = function Metadata() {
  var searchTerm = useAppSelector(function (state) {
    var _state$gacOverAllInfo;
    return (_state$gacOverAllInfo = state.gacOverAllInfo) === null || _state$gacOverAllInfo === void 0 || (_state$gacOverAllInfo = _state$gacOverAllInfo.selectedSuggestion) === null || _state$gacOverAllInfo === void 0 ? void 0 : _state$gacOverAllInfo.seoLabel;
  });
  if (!searchTerm || searchTerm.trim().length === 0) {
    return null;
  }
  var _buildSearchMetadata = buildSearchMetadata(searchTerm),
    title = _buildSearchMetadata.title,
    description = _buildSearchMetadata.description;
  if (!title || !description) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("meta", {
    name: "description",
    content: description
  }));
};
export default Metadata;